import { useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { MapMock } from "@/components/MapMock";
import { relativeTime } from "@/lib/format";

export const PortalTracking = () => {
  const [sites, setSites] = useState([]);
  const [active, setActive] = useState([]);
  const [guards, setGuards] = useState([]);

  const load = useCallback(async () => {
    const [s, a, g] = await Promise.all([
      api.get("/sites"),
      api.get("/clockins?active_only=true"),
      api.get("/guards"),
    ]);
    setSites(s.data);
    setActive(a.data);
    setGuards(g.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  // Filter to active guards whose site belongs to this client (sites already filtered by API)
  const visible = useMemo(() => {
    const siteIds = new Set(sites.map(s => s.id));
    return active.filter(a => siteIds.has(a.site_id));
  }, [active, sites]);

  const points = useMemo(() => visible.map(a => {
    const g = guards.find(x => x.id === a.guard_id);
    const s = sites.find(x => x.id === a.site_id);
    return {
      lat: a.lat, lng: a.lng,
      label: g?.full_name || "Guard",
      sub: `${s?.name} · ${relativeTime(a.clock_in_at)}`,
      alert: !a.inside_geofence,
    };
  }), [visible, guards, sites]);

  return (
    <div className="grid lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2">
        <MapMock points={points} sites={sites} height={520} />
      </div>
      <div className="s-card-light">
        <div className="h-section mb-3" style={{ color: "#0D1B2A" }}>On duty at your sites</div>
        <div className="space-y-2">
          {visible.map(a => {
            const g = guards.find(x => x.id === a.guard_id);
            const s = sites.find(x => x.id === a.site_id);
            return (
              <div key={a.id} className="p-3 rounded-lg" style={{ background: "#F4F6F9" }}>
                <div style={{ fontSize: 14, color: "#0D1B2A" }}>{g?.full_name}</div>
                <div className="text-muted" style={{ fontSize: 12 }}>{s?.name} · {relativeTime(a.clock_in_at)}</div>
              </div>
            );
          })}
          {visible.length === 0 && <div className="text-muted" style={{ fontSize: 13 }}>No guards currently on duty.</div>}
        </div>
      </div>
    </div>
  );
};
